const topicHubs = [
  {
    path: `/engineering-leadership/`,
    title: `Engineering Leadership`,
    description: `Practical writing by Wale Ayandiran about engineering leadership, team effectiveness, technical coaching, and making better decisions.`,
    intro: `Engineering leadership is the work of creating clarity, growing people, and helping teams make sound technical decisions. These essays cover the practices and lessons I have found most useful while building products and supporting engineers.`,
    topics: [
      `Engineering team effectiveness`,
      `Technical decision-making`,
      `Coaching and mentoring engineers`,
      `Sustainable software delivery`,
    ],
    postSlugs: [
      `/shared-api-platform-token-storms/`,
      `/the-engineering-meeting-paradox/`,
      `/scaling-frontend-apps-code-guidelines/`,
      `/html5-semantics-building-the-right-way/`,
      `/reboot-edinburgh-2025/`,
    ],
  },
  {
    path: `/ai-systems/`,
    title: `AI Systems and Autonomous Operators`,
    description: `Essays by Wale Ayandiran about AI systems, autonomous operators, AI agency, and the limits of current artificial intelligence.`,
    intro: `Useful AI systems need more than impressive model outputs. I write about agency, context, reliability, and what it takes to move from AI-assisted tools toward systems that can execute real work responsibly.`,
    topics: [
      `Autonomous worker operators`,
      `AI agency and context`,
      `Reliable AI product design`,
      `Artificial general intelligence`,
    ],
    postSlugs: [
      `/autonomous-worker-operators/`,
      `/OnBuddy-2025-reflection/`,
      `/we're-not-close-to-AGI-just-yet/`,
      `/artificial-what-ifs/`,
      `/big-data-analytics--better-decision-making/`,
    ],
  },
  {
    path: `/software-engineering/`,
    title: `Software Engineering`,
    description: `Technical articles by Wale Ayandiran about software architecture, frontend engineering, cloud infrastructure, and engineering practice.`,
    intro: `This collection brings together practical lessons from building and scaling software: choosing infrastructure, structuring frontend systems, using web standards, and helping engineers turn ideas into working products.`,
    topics: [
      `Software architecture and scale`,
      `Frontend engineering`,
      `Cloud infrastructure`,
      `Engineering standards and practice`,
    ],
    postSlugs: [
      `/shared-api-platform-token-storms/`,
      `/in-flight-token-refresh-deep-dive/`,
      `/gcp-cloud-run-and-app-engine/`,
      `/html5-semantics-building-the-right-way/`,
      `/scaling-frontend-apps-code-guidelines/`,
      `/access-previous-state/`,
      `/reboot-edinburgh-2025/`,
    ],
  },
]

module.exports = { topicHubs }
